export interface ResizeOptions {
  maxSize?: number
  quality?: number
  maxBytes?: number
}

export async function resizeImageToDataUrl(file: File, opts: ResizeOptions = {}): Promise<string> {
  const { maxSize = 256, quality = 0.8, maxBytes = 131072 } = opts

  const bitmap = await createImageBitmap(file)
  const size = Math.min(bitmap.width, bitmap.height)
  const sx = (bitmap.width - size) / 2
  const sy = (bitmap.height - size) / 2

  const canvas = new OffscreenCanvas(maxSize, maxSize)
  const ctx = canvas.getContext('2d')!
  ctx.drawImage(bitmap, sx, sy, size, size, 0, 0, maxSize, maxSize)
  bitmap.close()

  const blob = await canvas.convertToBlob({ type: 'image/jpeg', quality })

  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e): void => {
      const dataUrl = e.target?.result as string
      if (dataUrl.length > maxBytes) {
        reject(new Error('Image is too large even after compression.'))
        return
      }
      resolve(dataUrl)
    }
    reader.onerror = () => reject(new Error('Failed to read image.'))
    reader.readAsDataURL(blob)
  })
}
